import { getIdentityUtils } from '../../utils';
import { FLAG_COMMONSKU_PAYMENTS } from './CreditCardIntegration';

export const OPEN_QUERY_PARAM = 'open';
export const OPEN_COMMONSKU_PAYMENTS = 'commonsku-payments';


export function isCommonskuPaymentsDeepLink(search = window.location.search): boolean {
    const params = new URLSearchParams(search);
    return params.get(OPEN_QUERY_PARAM) === OPEN_COMMONSKU_PAYMENTS;
}

export function canAccessCommonskuPaymentsDeepLink(identity: {
    company_type?: string;
    capabilities?: string[];
    user_flags?: string[];
} | null | undefined): boolean {
    if (!identity || identity.company_type === 'SUPPLIER') {
        return false;
    }

    const { hasCapabilities, hasUserFlags } = getIdentityUtils(identity);
    return hasCapabilities(['MODIFY-SETTINGS']) && hasUserFlags([FLAG_COMMONSKU_PAYMENTS]);
}
